module.exports = __webpack_public_path__ + "img/spyware.11e3e93e.png";